// extracted by mini-css-extract-plugin
module.exports = {"title":"VEJBuRpuRxcwPlmTJW_IM","text":"_3MYcRKP1jna7eFSLarOje2","dialogModal":"_1Ij2ulQcsIndp9PdcSC1of","button":"_16jT-kqwKuGGhsC2EuP84u","input":"ybWzbwNHqHdM4oei9EImC"};